module.exports = __webpack_public_path__ + "img/199.8fb57efd.jpg";